import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listIg") };
export const campListSave  = (params) => { return req("post", "/customer/addIg", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteIg", params) };
export const campListAudit = (params) => { return axios.get("admin/camp/audit?id=" + params.id + "&status=" + params.status) }

// 获取景点详情列表
export const scDetailsList = (params) => { return axios.get("/admin/scDetails/list?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const scDetailsListSave  = (params) => { return req("post", "/admin/scDetails/save", params) };
export const scDetailsListUp  = (params) => { return req("post", "/admin/scDetails/update", params) };
export const scDetailsListDel  = (params) => { return req("post", "/admin/scDetails/delete", params) };

// 获取景点类型
export const campListType = (params) => { return axios.get("admin/camp/listtype?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const campListTypeSave  = (params) => { return req("post", "/admin/camp/typeupdate", params) };
export const campListTypeDel  = (params) => { return req("post", "/admin/camp/typedelete", params) };

// 获取景点攻略
export const campListInfo = (params) => { return axios.get("admin/camp/listinfo?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const campListInfoSave  = (params) => { return req("post", "/admin/camp/infoupdate", params) };
export const campListInfoDel  = (params) => { return req("post", "/admin/camp/infodelete", params) };


// 获取景点列表
export const userList = (params) => { return axios.get("admin/user/list?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const userSave  = (params) => { return req("post", "/admin/user/update", params) };
export const userDel  = (params) => { return req("post", "/admin/user/delete", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG3.js